<script setup>
import TileComponent from "@/components/Dashboard/Utilities/TileComponent.vue";
</script>

<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2"></div>
    </div>
  </div>

  <section class="content">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <h2 style="border-bottom: 2px">Automated Rockmongo</h2>
          <div class="row">
            <TileComponent
              boxColor="bg-info"
              title="Sections"
              description="Rockmongo"
              routerTo="sections"
              icon="puzzle-piece"
            />
            <TileComponent
              boxColor="bg-info"
              title="Driving Range Sections"
              description="Rockmongo"
              routerTo="driving-range-sections"
              icon="flag"
            />
            <TileComponent
              boxColor="bg-info"
              title="Holes"
              description="Rockmongo"
              routerTo="holes"
              icon="square-h"
            />
            <TileComponent
              boxColor="bg-info"
              title="Config"
              description="Rockmongo"
              routerTo="config"
              icon="plug"
            />
            <TileComponent
              boxColor="bg-info"
              title="Upload Map and Flags"
              description="Rockmongo"
              routerTo="map-flags"
              icon="map-location-dot"
            />
            <TileComponent
              boxColor="bg-success "
              title="Future Default Tee-Times"
              description="Rockmongo"
              routerTo="default-tee-times"
              icon="calendar-check"
            />
            <TileComponent
              boxColor="bg-info"
              title="Course Outlines"
              description="Rockmongo"
              routerTo="course-outlines"
              icon="draw-polygon"
            />
            <TileComponent
              boxColor="bg-info"
              title="Teesheet Integration Setup"
              description="Rockmongo"
              routerTo="teesheet-integration"
              icon="handshake"
            />
            <TileComponent
              boxColor="bg-info"
              title="Golf Weather Integration"
              description="Rockmongo"
              routerTo="golf-weather-integration"
              icon="cloud-sun"
            />
            <TileComponent
              boxColor="bg-info"
              title="Driving Range QR Code"
              description="Rockmongo"
              routerTo="driving-range-qr-code"
              icon="flag"
            />
            <TileComponent
              boxColor="bg-info"
              title="Driving Range Pins"
              description="Rockmongo"
              routerTo="driving-range-pins"
              icon="flag"
            />
          </div>
          <br />

          <h2 style="border-bottom: 2px">Reporting</h2>
          <div class="row">
            <TileComponent
              boxColor="bg-danger"
              title="App Crashes"
              description="Reporting"
              icon="file-excel"
            />
            <TileComponent
              boxColor="bg-danger"
              title="Geofence Breaches"
              description="Reporting"
              icon="file-excel"
            />
            <TileComponent
              boxColor="bg-muted"
              title="Utility Logs"
              description="Reporting"
              icon="file-excel"
            />
          </div>
          <br />

          <h2 style="border-bottom: 2px">Fixes</h2>
          <div class="row">
            <TileComponent
              boxColor="bg-success"
              title="Re-sending Fixes"
              description="Fixes"
              icon="gear"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
